import { autotraceItemFields } from '@/pages/autotrace/models/autotrace-fields'
import { allBlockchainCoin, allTokensItem } from '@/assets/static/currency-list'
export default {
  getShowCreateEditModal: state => state.showCreateEditModal ?? false,
  getModalAction: state => state.modalAction ?? 'create',
  getCreateEditModalData: state =>
    state.createEditModalData ?? autotraceItemFields(),
  getActiveBlockchain: state => state.activeBlockchain ?? allBlockchainCoin,
  getActiveToken: state => state.activeToken ?? allTokensItem,
  getActiveSearchField: state => state.activeSearchField ?? '',
  getCaseActiveTab: state => state.caseActiveTab,
  getCaseInfo: state => state.caseInfo ?? {},
  getCheckedAlertsMap: state => state.checkedAlertsMap,
  getCheckedAlertsCount: state => state.checkedAlertsCount,
  getEntityIconCache: (state) => (name) => {
    return state.entityIconCache[name] || null
  },
  getReloadAutotraceCaseTrigger: state => state.reloadAutotraceCaseTrigger,
  getClearTrigger: state => state.clearTrigger,
}
